"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _maybe = _interopRequireDefault(require("./maybe"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Component = function Component(_ref) {
  var of = _ref.of,
      map = _ref.map,
      either = _ref.either,
      orElse = _ref.orElse;
  return _maybe.default.of(of).mapAll(map).fold(orElse, either);
};

var _default = Component;
exports.default = _default;